<div 
    class="view-list-item"
    [ngClass]="{'view-list-item--selected': selected}">
    <ng-content></ng-content>
</div>